import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select, { OptionType, SelectValueType } from 'src/components/Select';
import { ProviderType } from 'src/types/provider';
import { UserType } from 'src/types/user';
import { OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface UsersPropsType {
    data: ProviderType | null;
    usersData: UserType[] | null;
    onChange: OnChangeType<EditKeysType>;
    editData: ProviderType;
    disableEdit: boolean;
}

const Users: FC<UsersPropsType> = (props) => {
    const [usersOptions, setUsersOptions] = useState<OptionType[]>([]);
    const [selectedUsers, setSelectedUsers] = useState<SelectValueType[]>([]);
    const [usersNotificatedOptions, setUsersNotificatedOptions] = useState<OptionType[]>([]);
    const [selectedNotificatedUsers, setSelectedNotificatedUsers] = useState<SelectValueType[]>([]);

    useEffect(() => {
        if (props.usersData) {
            setUsersOptions(props.usersData.map((user) => ({ value: user.USER_EMAIL, label: user.USER_EMAIL || '' })));
        }
    }, [props.usersData]);

    useEffect(() => {
        if (props.editData.PROVIDER_USERS) {
            setSelectedUsers(props.editData.PROVIDER_USERS?.map((user) => user.USER_EMAIL || ''));
            setUsersNotificatedOptions(
                props.editData.PROVIDER_USERS?.map((user) => ({ value: user.USER_EMAIL, label: user.USER_EMAIL || '' }))
            );
            setSelectedNotificatedUsers(
                props.editData.PROVIDER_USERS?.filter((user) => user.NOTIFICATION_ACTIVE).map(
                    (user) => user.USER_EMAIL || ''
                )
            );
        }
    }, [props.editData.PROVIDER_USERS]);

    if (!props.usersData) {
        return null;
    }

    const handleChangeUsers = (value: SelectValueType | SelectValueType[]) => {
        if (!props.editData.PROVIDER_USERS || !Array.isArray(value)) {
            return;
        }

        let updatedProviderUsers = [...props.editData.PROVIDER_USERS];

        if (value.length < props.editData.PROVIDER_USERS.length) {
            updatedProviderUsers = updatedProviderUsers.filter((providerUser) =>
                value.find((email) => email === providerUser.USER_EMAIL)
            );
        } else {
            const newUsers = value.filter(
                (email) => !updatedProviderUsers.find((providerUser) => email === providerUser.USER_EMAIL)
            );

            newUsers.forEach((email) => {
                const oldUser = props.data?.PROVIDER_USERS?.find((providerUser) => providerUser.USER_EMAIL === email);

                if (oldUser) {
                    updatedProviderUsers.push({ ...oldUser } as any);
                } else {
                    updatedProviderUsers.push({
                        USER_EMAIL: String(email || ''),
                        NOTIFICATION_ACTIVE: 1,
                    } as any);
                }
            });
        }

        props.onChange('PROVIDER_USERS', updatedProviderUsers, false);
    };

    const handleChangeNotificatedUsers = (value: SelectValueType | SelectValueType[]) => {
        if (!props.editData.PROVIDER_USERS || !Array.isArray(value)) {
            return;
        }

        let updatedProviderUsers = [...props.editData.PROVIDER_USERS];

        updatedProviderUsers = updatedProviderUsers.map((providerUser) => ({
            ...providerUser,
            NOTIFICATION_ACTIVE: value.find((email) => email === providerUser.USER_EMAIL) ? 1 : 0,
        }));

        props.onChange('PROVIDER_USERS', updatedProviderUsers, false);
    };

    return (
        <Grid>
            <GridItem cols={12}>
                <Select
                    options={usersOptions}
                    value={selectedUsers}
                    onChange={handleChangeUsers}
                    name="SERVICE_CODES"
                    label={translate('providerDetail.users')}
                    fullWidth
                    multiple
                    limitTags={20}
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={12}>
                <Select
                    options={usersNotificatedOptions}
                    value={selectedNotificatedUsers}
                    onChange={handleChangeNotificatedUsers}
                    name="SERVICE_CODES"
                    label={translate('providerDetail.usersNotificate')}
                    fullWidth
                    multiple
                    limitTags={20}
                    disabled={props.disableEdit}
                />
            </GridItem>
        </Grid>
    );
};

export default Users;
